if (!customElements.get('split-sticky-section')) {
  customElements.define(
    'split-sticky-section',
    class SplitStickySection extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('split-sticky--reduced-motion');
        }
      }
    }
  );
}
